import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue } from '../../Custom/Custom';
import BlockJJsonData from '../../assets/BlockJData.json';
import asiTitle from '../../asi.json';



export default function BlockJ({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

  const [itemData, setItemData] = useState({});
  const [originalValues, setOriginalValues] = useState({}); 
  const navigate = useNavigate();
  const yearRange = generateYearRange(blockInfo.surveyYear);
  const [buttonStatus, setButtonStatus] = useState('');
  const [statusFlageval, setStatusFlageval] = useState('');
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split('|')
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isDivasiRole = roleCodes.includes('DIVASI');
  const isDivasiStatusFlagOne = isDivasiRole && String(statusFlageval ?? '').trim() === '1';
  const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
  const isHqStatusFlagThree = isHqRole && String(statusFlageval ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(statusFlageval ?? '').trim() === '';
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(11);
  })();
  const [checkedItems, setCheckedItems] = useState([]);
  const [blockgdata, setblockgdata] = useState([]);
  const [blockDData, setBlockDData] = useState([]); 
  const dtableRef = useRef(4);
  const [exFactoryValueClass, setExFactoryValueClass] = useState({}); 
  const [perUnitNetSaleValueClass, setPerUnitNetSaleValueClass] = useState({}); 
  let srNo = 0;
  let staticNo = 10;
  const itemCodeArray = ['9921100', '9995000', '9999900'];
  const statusUnitCode = localStorage.getItem('statusUnitCode')

  useEffect(() => {
    // console.log("BlockJ component loaded");
    // console.log("blockInfo:", blockInfo);
    // console.log("surveyYear:", blockInfo?.surveyYear);
    blockJData();
    fetchBlockDData(); // Fetch Block D data for validation
  }, [])

  // Function to fetch Block D data
  const fetchBlockDData = async () => {
    const newObject = {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    };
    try {
      const response = await axios.post(`${API_URL}api/asi/blockDForm`, newObject, config);
      const { data, status } = response.data;
      if (status && data.blockDData) {
        setBlockDData(data.blockDData);
      }
    } catch (error) {
      console.error('Error fetching Block D data:', error);
    }
  }



  // Function to handle page load fromdata
  const blockJData = async () => {
    const newObject = {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    };
    showAppLoading(true)
    try {
      const response = await axios.post(`${API_URL}api/asi/blockJForm`, newObject, config);
      const { data, status } = response.data;
      let responseBlockJData = '';
      let statusFlage = '';

      setblockgdata(data.paramG.valuesG);

      if (status) {
        let dy = 0;
        if (data.blockJData.length > 3) {
          dy = -1
        }

        responseBlockJData = addNineEmptyRow(data.blockJData, 'dynamic', dy);
        statusFlage = responseBlockJData?.[responseBlockJData.length - 1]?.statusFlag ?? '';
      } else {
        responseBlockJData = addNineEmptyRow(BlockJJsonData, 'static', 0);
        statusFlage = ''
      }
      setStatusFlageval(statusFlage);
      const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
      customObjectObjectData(responseBlockJData)
      setButtonStatus(IsButtonStatus)
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showAppLoading(false);
    }

  }

  // Function to handle update state on change event
  const handleOnChange = (IndexId, field, newValue) => {
    // Log all inputs for Item 11 (Other products/by-products)
    const currentItem = itemData[IndexId];
    if (currentItem && String(currentItem.itemCode).trim() === '9921100') {
      console.log(`🔵 Item 11 (Row ${IndexId}) - User Input:`, {
        field: field,
        newValue: newValue,
        oldValue: currentItem[field],
        allItemData: {
          itemCode: currentItem.itemCode,
          qtyManufactured: currentItem.qtyManufactured,
          qtySold: currentItem.qtySold,
          grossSaleValue: currentItem.grossSaleValue,
          distributiveExpensesExciseDuty: currentItem.distributiveExpensesExciseDuty,
          distributiveExpensesSalesTaxVat: currentItem.distributiveExpensesSalesTaxVat,
          distributiveExpensesOthers: currentItem.distributiveExpensesOthers,
          distributiveExpensesTotal: currentItem.distributiveExpensesTotal,
          perunitNetsaleValue: currentItem.perunitNetsaleValue,
          exfactoryValueQty: currentItem.exfactoryValueQty
        }
      });
    }

    // Column 13 (exfactoryValueQty) - Only allow integers (no decimals)
    // Handle this BEFORE isNumeric check to avoid duplicate toast messages
    if (field === 'exfactoryValueQty') {
      // Remove any decimal point and digits after decimal
      if (newValue.includes('.')) {
        const storedLanguage = localStorage.getItem('language');
        const errorMessage = storedLanguage === 'hi'
          ? 'केवल अंक ही अनुमत हैं।'
          : 'Only Digit Allowed';
        toast.error(errorMessage, messages.COLOR_RED);
        // Remove decimal and everything after it
        newValue = newValue.split('.')[0];
      }
      // Only allow digits (0-9)
      if (newValue && !/^\d+$/.test(newValue)) {
        const storedLanguage = localStorage.getItem('language');
        const errorMessage = storedLanguage === 'hi'
          ? 'कृपया केवल संख्याएं दर्ज करें।'
          : 'Please enter numbers only.';
        toast.error(errorMessage, messages.COLOR_RED);
        return false;
      }
      // For exfactoryValueQty, skip isNumeric check since we already validated it
      // Continue to update the state with cleaned value
    } else {
      // For other fields, apply isNumeric check
      if (!isNumeric(newValue)) {
        toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
        newValue = '';
      }
    }

    if (field === 'perunitNetsaleValue') {

      if (!/^\d*\.?\d{0,2}$/.test(newValue)) {
        toast.error('After Decimal more than two digit cannot allow.', messages.COLOR_RED);
        return false;
      }
    }

    // Track original value for itemCode field when user first starts typing
    if (field === 'itemCode' && !originalValues[IndexId]) {
      const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
      setOriginalValues(prev => ({
        ...prev,
        [IndexId]: currentValue
      }));
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [IndexId]: {
          ...prevItemData[IndexId],
          [field]: newValue
        }
      };

      // Real-time validation and highlighting for Column 5 and Column 6 - REMOVED Block D validation

      return updatedItemData;
    });
  }

  // Function to highlight cells based on Block D Item 6 validation - REMOVED

  // Function to handle focus event - store original value when user first focuses on itemCode field
  const handleOnFocus = (IndexId, field) => {
    if (field === 'itemCode' && !originalValues[IndexId]) {
      const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
      console.log('Storing original value for IndexId:', IndexId, 'Value:', currentValue);
      setOriginalValues(prev => ({
        ...prev,
        [IndexId]: currentValue
      }));
    }
  }

  const handleOnBlur = async (IndexId, newValue) => {
    // Check if value has actually changed
    const originalValue = originalValues[IndexId] || '';
    
    console.log('handleOnBlur - IndexId:', IndexId, 'Original Value:', originalValue, 'New Value:', newValue);
    
    // If value hasn't changed, don't make API call
    if (originalValue === newValue) {
      console.log('Value unchanged, skipping API call for IndexId:', IndexId);
      // Clear the original value tracking for this field
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
      return false;
    }

    let newItemAdded = {
      "id": IndexId,
      "dslNo": blockInfo.dslNo,
      "surveyYear": blockInfo.surveyYear,
      "itemDesc": '',
      "itemCode": '',
      "unitOfQty": '',
      "qtyManufactured": '',
      "qtySold": '',
      "grossSaleValue": '',
      "perunitNetsaleValue": '',
      'exfactoryValueQty': '',
      "statusFlag": '',
      "distributiveExpensesExciseDuty": '',
      "distributiveExpensesSalesTaxVat": '',
      "distributiveExpensesOthers": '',
      "distributiveExpensesTotal": '',
      "itemCodeClass": "textBox_back_color_white",
    }

    if (newValue === '') {
      newItemAdded.itemCode = "";
      handleTableRowData(IndexId, newItemAdded)
      // Clear original value tracking
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
      return false;
    }

    // If NPCMS code is provided, try to fetch data
    if (newValue.length >= 7) {
      const asicc_code = newValue
      const newObject = {
        asicc_code: asicc_code,
        "page_type": "BlockJ"
      };

      showAppLoading(true);
      try {
        const response = await axios.post(`${API_URL}api/asi/BlockHFetchDataByItemCodeNPCMS`, newObject, config);
        const { data, status } = response.data;
        console.log("response",response.data.data.blockHData)
        if (status) {
          const response = data.blockHData;
          newItemAdded.id = IndexId
          newItemAdded.dslNo = blockInfo.dslNo
          newItemAdded.surveyYear = blockInfo.surveyYear
          newItemAdded.itemDesc = response.itemName
          newItemAdded.itemCode = asicc_code
          newItemAdded.unitOfQty = response.unitOfQty
          newItemAdded.itemCodeClass = "textBox_back_color_white"
        } else {
          newItemAdded.id = IndexId
          newItemAdded.dslNo = blockInfo.dslNo
          newItemAdded.surveyYear = blockInfo.surveyYear
          newItemAdded.itemDesc = ''
          newItemAdded.itemCode = asicc_code
          newItemAdded.itemCodeClass = "textBox_back_color_white"
          // Don't show error for invalid NPCMS code - allow user to proceed
        }
        handleTableRowData(IndexId, newItemAdded)
      } catch (error) {
        console.error(error);
        // Don't show error - allow user to proceed with manual entry
        newItemAdded.id = IndexId
        newItemAdded.dslNo = blockInfo.dslNo
        newItemAdded.surveyYear = blockInfo.surveyYear
        newItemAdded.itemDesc = ''
        newItemAdded.itemCode = newValue
        newItemAdded.itemCodeClass = "textBox_back_color_white"
        handleTableRowData(IndexId, newItemAdded)
      } finally {
        showAppLoading(false);
        // Clear original value tracking in all exit points (success, error, early return)
        setOriginalValues(prev => {
          const newState = { ...prev };
          delete newState[IndexId];
          return newState;
        });
      }
    } else {
      // Allow user to enter any value (even less than 7 characters)
      newItemAdded.id = IndexId
      newItemAdded.dslNo = blockInfo.dslNo
      newItemAdded.surveyYear = blockInfo.surveyYear
      newItemAdded.itemDesc = ''
      newItemAdded.itemCode = newValue
      newItemAdded.itemCodeClass = "textBox_back_color_white"
      handleTableRowData(IndexId, newItemAdded)
      
      // Clear original value tracking
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
    }
  }


  const handleTableRowData = (IndexId, newItemAdded) => {
    setItemData(prevItemData => ({
      ...prevItemData,
      [IndexId]: {
        ...prevItemData[IndexId],
        ...newItemAdded
      }
    }));
    return true;
  }

  // Function to handle Added 9 empty row on page Load  
  const addNineEmptyRow = (responseBlockJData, dataType, emptyRowCount) => {
    let customObject = [];
    let mergedArray = '';
    for (let i = 0; i <= emptyRowCount; i++) {
      const newItemAdded = {
        "dslNo": blockInfo.dslNo,
        "surveyYear": blockInfo.surveyYear,
        "itemDesc": "",
        "itemCode": "",
        "unitOfQty": "",
        "qtyManufactured": "",
        "qtySold": "",
        "grossSaleValue": "",
        "perunitNetsaleValue": "",
        "exfactoryValueQty": "",
        "statusFlag": "",
        "distributiveExpensesExciseDuty": "",
        "distributiveExpensesSalesTaxVat": "",
        "distributiveExpensesOthers": "",
        "distributiveExpensesTotal": ""
      };
      customObject.push(newItemAdded);
    }

    if (dataType === "dynamic") {
      const dataArray = Object.values(responseBlockJData);
      const AddedIndex = dataArray.length - 3
      mergedArray = [
        ...responseBlockJData.slice(0, AddedIndex),
        ...customObject,
        ...responseBlockJData.slice(AddedIndex)
      ];
    } else if (dataType === "static") {
      mergedArray = [
        ...responseBlockJData.slice(0, 0),
        ...customObject,
        ...responseBlockJData.slice(0)
      ];
    }


    return mergedArray;
  };


  // Function to handle Added one row on button click
  const addRow = () => {
    let newCustomObject = [];
    for (let i = 0; i < 1; i++) {
      const newItemAdded = {
        "dslNo": blockInfo.dslNo,
        "surveyYear": blockInfo.surveyYear,
        "itemDesc": "",
        "itemCode": "",
        "unitOfQty": "",
        "qtyManufactured": "",
        "qtySold": "",
        "grossSaleValue": "",
        "perunitNetsaleValue": "",
        "exfactoryValueQty": "",
        "statusFlag": "",
        "distributiveExpensesExciseDuty": "",
        "distributiveExpensesSalesTaxVat": "",
        "distributiveExpensesOthers": "",
        "distributiveExpensesTotal": ""
      };
      newCustomObject.push(newItemAdded);
    }
    const dataArray = Object.values(itemData);
    const AddedIndex = dataArray.length - 3
    dataArray.splice(AddedIndex, 0, ...newCustomObject);
    customObjectObjectData(dataArray)
  };


  // Function to handle update state according to data  
  const customObjectObjectData = (responseBlockJData) => {
    const initialData = {};
    responseBlockJData.forEach((item, index) => {
      initialData[index] = {
        id: index,
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemDesc: item.itemDesc,
        itemCode: item.itemCode,
        unitOfQty: item.unitOfQty,
        qtyManufactured: item.qtyManufactured,
        qtySold: item.qtySold,
        grossSaleValue: item.grossSaleValue,
        perunitNetsaleValue: item.perunitNetsaleValue,
        exfactoryValueQty: item.exfactoryValueQty,
        statusFlag: item.statusFlag,
        distributiveExpensesExciseDuty: item.distributiveExpensesExciseDuty,
        distributiveExpensesSalesTaxVat: item.distributiveExpensesSalesTaxVat,
        distributiveExpensesOthers: item.distributiveExpensesOthers,
        distributiveExpensesTotal: item.distributiveExpensesTotal,
        qtyManufacturedClass: 'textBox_back_color_white',
        qtySoldClass: 'textBox_back_color_white',

      };
    });

    setItemData(initialData);
  }

  // Function to handle the store chckbox checked data 
  const handleCheckboxChange = (event, index) => {
    if (event.target.checked) {
      setCheckedItems([...checkedItems, index]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== index));
    }
  };

  // Function to handle delete row
  const DeleteRow = () => {
    const dataArray = Object.values(itemData);

    if (checkedItems.length === 0) {
      toast.error('Please select at least one row for deletion.', messages.COLOR_RED);
      return false;
    }

    const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
    customObjectObjectData(updatedItems)
    setCheckedItems([]);
  };


  // Function to handle reset Form Data
  const handleReset = () => {
    const initialData = {};
    const dataArray = Object.values(itemData);
    dataArray.forEach((item, index) => {
      initialData[index] = {
        id: index,
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemCode: item.itemCode,
        itemDesc: item.itemDesc,
        unitOfQty: '',
        qtyManufactured: '',
        qtySold: '',
        grossSaleValue: '',
        perunitNetsaleValue: '',
        exfactoryValueQty: '',
        statusFlag: '',
        distributiveExpensesExciseDuty: '',
        distributiveExpensesSalesTaxVat: '',
        distributiveExpensesOthers: '',
        distributiveExpensesTotal: '',

      };
    });

    setItemData(initialData);
  }

  // Function to handle going to the previous block 
  const handlePrevious = () => {
    const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
      // handleSaveData("SAVE")
      navigate("/BlockI")
    }
  }

  // Function to handle going to the next block      
  const handleNext = async () => {
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
        navigate("/BlockK");
        return;
      }
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
        navigate("/BlockK");
        return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
        navigate("/BlockK");
        return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;
      if (statusUnitCode === '5') {
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
          blockValidation()
          navigate("/BlockK")
        }
      } else {
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
          blockValidation()
          navigate("/BlockK")
        }
      }

  }


  //All block validation Data
  const blockValidation = async () => {

    let postData = {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    }

    try {
      showAppLoading(true);
      const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
      const { data, status } = response.data;
      const accessIds = data.allblockData
      if (accessIds.length > 0) {
        if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].length) {
          accessAsiBlock(accessIds)
        } else {
          accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
        }

      } else {
        accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
      }
      showAppLoading(false);
      return true;

    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {

    }

  }



  // Function to handle update and save form data
  const handleSaveData = async (buttonType) => {

    const statusUnitCode = localStorage.getItem('statusUnitCode');
    if (!(statusUnitCode === '4' || statusUnitCode === '5' || statusUnitCode === '7' || statusUnitCode === '8')) {
      if (statusUnitCode !== '5' && !valForBlockJ()) {
        return false;
      }
    }
    let allObjectData = itemData;

    let customItemCodes = [];

    const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

    for (let id in allObjectData) {
      // Allow saving rows even without itemCode - NPCMS is no longer mandatory
      const customObject = {
        dslNo: allObjectData[id].dslNo,
        surveyYear: allObjectData[id].surveyYear,
        itemCode: allObjectData[id].itemCode || '',
        itemDesc: allObjectData[id].itemDesc || '',
        unitOfQty: handleValue(allObjectData[id].unitOfQty),
        qtyManufactured: handleValue(allObjectData[id].qtyManufactured),
        qtySold: handleValue(allObjectData[id].qtySold),
        grossSaleValue: handleValue(allObjectData[id].grossSaleValue),
        perunitNetsaleValue: handleValue(allObjectData[id].perunitNetsaleValue),
        exfactoryValueQty: handleValue(allObjectData[id].exfactoryValueQty),
        distributiveExpensesExciseDuty: handleValue(allObjectData[id].distributiveExpensesExciseDuty),
        distributiveExpensesSalesTaxVat: handleValue(allObjectData[id].distributiveExpensesSalesTaxVat),
        distributiveExpensesOthers: handleValue(allObjectData[id].distributiveExpensesOthers),
        distributiveExpensesTotal: handleValue(allObjectData[id].distributiveExpensesTotal),
        statusFlag: clickButtonStatusFlag
      };
      customItemCodes.push(customObject);
    }

    const newObject = {
      itemCodes: customItemCodes,
      payload: {
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear,
        buttonType: buttonType
      }
    }

    showAppLoading(true);

    try {
      const response = await axios.post(`${API_URL}api/asi/blockJFormSaveToDB`, newObject, config);
      const { status, message } = response.data;
      if (status) {
        blockValidation()
        toast.success(message, messages.COLOR_RED);
        return true;
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showAppLoading(false);
    }

    return false;


  }

  const handleValue = (value) => {
    return (value !== "" && value !== null && value !== undefined) ? value : 0;
  };

  const valForBlockJ = () => {

    // Initialize Item 11 validation passed flag
    window.item11ValidationPassed = {};
    
    // Track Item 11 value that was excluded from v13 in loop
    // Only track if it's from last3 row (rowCount - 3)
    window.item11ExcludedValue = null;
    window.item11ExcludedRowIndex = null;

    let flagJ = 0;
    let v7 = 0;
    let v8 = 0;
    let v9 = 0;
    let v10 = 0;
    let v11 = 0;
    let v13 = 0;
    const tbl = document.getElementById('velBlockJ');
    const rowCount = tbl.rows.length;
    let rowNum = 3;
    const totalRow = rowCount - 1;
    const surveyYear = blockInfo.surveyYear;
    const statusUnitCode = localStorage.getItem('statusUnitCode');
    let allValidactionAlertBlockJ = "";
    let allSoftValidactionAlertBlockJ = "";
    let statusAlertJ = 0;
    const yearArray = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];


    if (yearArray.includes(surveyYear)) {



      for (let i = 0; i < rowCount - 5; i++) {

        const val3 = handleValue(document.getElementById("itemCode" + i).value);
        const val5 = handleValue(document.getElementById("qtyManufactured" + i).value);
        let val6 = handleValue(document.getElementById("qtySold" + i).value);
        const val7 = handleValue(document.getElementById("grossSaleValue" + i).value);
        const val8 = handleValue(document.getElementById("distributiveExpensesExciseDuty" + i).value);
        const val9 = handleValue(document.getElementById("distributiveExpensesSalesTaxVat" + i).value);
        const val10 = handleValue(document.getElementById("distributiveExpensesOthers" + i).value);
        const val11 = handleValue(document.getElementById("distributiveExpensesTotal" + i).value);
        const val12 = handleValue(document.getElementById("perunitNetsaleValue" + i).value);
        const val13 = handleValue(document.getElementById("exfactoryValueQty" + i).value);


        // NPCMS code validation removed - user can enter any code including starting with 0
        const rowNumCout3 = tbl.rows[rowNum];
        let cellSecund = rowNumCout3.cells[2];
        cellSecund.style.backgroundColor = 'white';

        // Item 11 "Other products/by-products" (itemCode: '9921100') - Mandatory Ex-Factory Value validation
        // If Column 7 (Gross sale Value) has value, then Column 13 (Ex-Factory Value) is mandatory and must equal Column 7
        const itemCodeStr = String(val3).trim();
        if (itemCodeStr === '9921100') {
          // Get raw values directly from input fields - don't use handleValue
          const val7Input = document.getElementById("grossSaleValue" + i);
          const val13Input = document.getElementById("exfactoryValueQty" + i);
          const val7Raw = val7Input ? val7Input.value.trim() : '';
          const val13Raw = val13Input ? val13Input.value.trim() : '';
          
          // Parse values - only parse if not empty
          const val7Num = val7Raw !== '' && !isNaN(parseFloat(val7Raw)) ? parseFloat(val7Raw) : 0;
          const val13Num = val13Raw !== '' && !isNaN(parseFloat(val13Raw)) ? parseFloat(val13Raw) : 0;
          
          
          if (val7Num > 0) {
            // Column 13 is mandatory if Column 7 has value
            if (val13Raw === '' || val13Raw === null || val13Raw === undefined || isNaN(val13Num) || val13Num === 0) {
              const rowNumCout13 = tbl.rows[rowNum];
              let cell13 = rowNumCout13.cells[12]; // Column 13 (Ex-Factory Value)
              if (cell13) {
                cell13.style.backgroundColor = '#FF0000';
              }
              // Update state for input field highlighting
              setExFactoryValueClass(prev => ({
                ...prev,
                [i]: 'textBox_back_color_red'
              }));
              allValidactionAlertBlockJ = allValidactionAlertBlockJ + " Item 11 (Other products/by-products): If Column 7 (Gross sale Value) has value, then Column 13 (Ex-Factory Value) is mandatory. \n";
              flagJ = 1;
              statusAlertJ = 1;
            } 
            // Column 13 must equal Column 7 - strict validation
            else {
              // Use tolerance for floating point comparison
              const tolerance = 0.01;
              const valueDifference = Math.abs(val13Num - val7Num);
              
              if (valueDifference > tolerance) {
                const rowNumCout13 = tbl.rows[rowNum];
                let cell13 = rowNumCout13.cells[12];
                if (cell13) {
                  cell13.style.backgroundColor = '#FF0000';
                }
                // Update state for input field highlighting
                setExFactoryValueClass(prev => ({
                  ...prev,
                  [i]: 'textBox_back_color_red'
                }));
                allValidactionAlertBlockJ = allValidactionAlertBlockJ + ` Item 11 (Other products/by-products): Column 13 (Ex-Factory Value) must equal Column 7 (Gross sale Value). Column 7 Value: ${val7Num}, Column 13 Value: ${val13Num}. \n`;
                flagJ = 1;
                statusAlertJ = 1;
              } 
              // Values match - remove highlighting and don't set error flag
              else {
                const rowNumCout13 = tbl.rows[rowNum];
                let cell13 = rowNumCout13.cells[12];
                if (cell13) {
                  cell13.style.backgroundColor = 'white';
                  cell13.style.backgroundColor = '#FFFFFF'; // Force white
                }
                // Update state to remove highlighting
                setExFactoryValueClass(prev => ({
                  ...prev,
                  [i]: 'textBox_back_color_white'
                }));
                // IMPORTANT: Don't set flagJ = 1 if values match - validation passes
                // Don't add any error message
                // Mark that Item 11 validation passed - we'll use this later to prevent other validations
                if (!window.item11ValidationPassed) {
                  window.item11ValidationPassed = {};
                }
                window.item11ValidationPassed[i] = true;
              }
            }
          } else {
            // If Column 7 is empty or 0, remove highlighting and no validation needed
            const rowNumCout13 = tbl.rows[rowNum];
            let cell13 = rowNumCout13.cells[12];
            if (cell13) {
              cell13.style.backgroundColor = 'white';
            }
            setExFactoryValueClass(prev => ({
              ...prev,
              [i]: 'textBox_back_color_white'
            }));
            // No validation error if Column 7 is empty
          }
        }

        // Block D Item 6 validation - REMOVED as per user request
        
        const rowNumCout5 = tbl.rows[rowNum];
        let cellFive = rowNumCout5.cells[4]; // Column 5: Qty. Manufactured
        const rowNumCout = tbl.rows[rowNum];
        let cellSix = rowNumCout.cells[5]; // Column 6: Qty. Sold
        
        const val5Num = parseFloat(val5) || 0;
        const val6Num = parseFloat(val6) || 0;

        const rowNumCout6 = tbl.rows[rowNum];
        let cellSeven = rowNumCout6.cells[6];
        if (parseFloat(val6) > 0) {
          if (parseFloat(val7) > 0) {
            cellSeven.style.backgroundColor = 'white';
          } else {
            cellSeven.style.backgroundColor = '#FF0000';
            allValidactionAlertBlockJ = allValidactionAlertBlockJ + " Col. 7>0, if col. 6> 0. \n";
            statusAlertJ = 1;
            flagJ = 1;
          }
        }

        // Skip this validation for Item 11 "Other products/by-products" (itemCode: '9921100')
        const isItem11 = (String(val3).trim() === '9921100');
        
        if (parseFloat(val7) > 0) {
          if (parseFloat(val6) > 0) {
            cellSix.style.backgroundColor = 'white';
          } else {
            // Don't apply this validation for Item 11
            if (!isItem11) {
              cellSix.style.backgroundColor = '#FF0000';
              allValidactionAlertBlockJ = allValidactionAlertBlockJ + " Col. 6>0, if col. 7> 0. \n";
              statusAlertJ = 1;
              flagJ = 1;
            } else if (isItem11) {
              // For Item 11, don't show validation error for Column 6
              cellSix.style.backgroundColor = 'white';
            }
          }
        }

        // Apply existing validation
        let colorRed = true;
        if (parseFloat(val5) > 0 && parseFloat(val6) > 0) {
          if ((parseFloat((val6 - val5) / val5) * 100) < 100) {
            cellFive.style.backgroundColor = 'white';
            cellSix.style.backgroundColor = 'white';
          } else {
            cellFive.style.backgroundColor = '#FF0000';
            cellSix.style.backgroundColor = '#FF0000';
            colorRed = false;
            allValidactionAlertBlockJ = allValidactionAlertBlockJ + "  ((Col6-Col5)/Col5)*100)<100 \n";
            flagJ = 1;
            console.log(`❌ Validation FAILED (Row ${i}): ((Col6-Col5)/Col5)*100) must be < 100`);
            statusAlertJ = 1;
          }
        }

        if (parseFloat(val5) > 0 && parseFloat(val6) > 0) {
          if ((parseFloat((val5 - val6) / val6) * 100) < 100) {
            if (colorRed) {
              cellFive.style.backgroundColor = 'white';
              cellSix.style.backgroundColor = 'white';
            }
          } else {
            cellFive.style.backgroundColor = '#ffaa00';
            cellSix.style.backgroundColor = '#ffaa00';
            allSoftValidactionAlertBlockJ = allSoftValidactionAlertBlockJ + "  ((Col5-Col6)/Col6)*100)<100, \n";
            statusAlertJ = 1;
          }
        }


        // Track which values are being added to v7 for debugging
        const val7Num = parseFloat(val7) || 0;
        if (val7Num > 0) {
          console.log(`📊 Loop Row ${i} (Item Code: ${val3}): Adding Column 7 value = ${val7Num} to v7`);
        }
        
        v7 = parseFloat(v7) + parseFloat(val7);
        v8 = parseFloat(v8) + parseFloat(val8);
        v9 = parseFloat(v9) + parseFloat(val9);
        v10 = parseFloat(v10) + parseFloat(val10);
        v11 = parseFloat(v11) + parseFloat(val11);
        
        // For Item 11 (Row 11), if Column 7 and Column 13 match, don't add Column 13 to total
        // because it's manually entered and equals Column 7, not calculated
        const isItem11ForTotal = (String(val3).trim() === '9921100');
        let shouldExcludeFromV13 = false;
        
        if (isItem11ForTotal) {
          const val7Input = document.getElementById("grossSaleValue" + i);
          const val13Input = document.getElementById("exfactoryValueQty" + i);
          if (val7Input && val13Input) {
            const val7Raw = val7Input.value.trim();
            const val13Raw = val13Input.value.trim();
            const val7Num = val7Raw !== '' && !isNaN(parseFloat(val7Raw)) ? parseFloat(val7Raw) : 0;
            const val13Num = val13Raw !== '' && !isNaN(parseFloat(val13Raw)) ? parseFloat(val13Raw) : 0;
            
            // If Column 7 and Column 13 match, exclude from v13 calculation
            if (val7Num > 0 && Math.abs(val13Num - val7Num) <= 0.01) {
              shouldExcludeFromV13 = true;
              // Store the excluded value and row index so we can add it later after loop
              // Only store if this is the last3 row (rowCount - 3), otherwise it's already handled
              const tbl = document.getElementById('velBlockJ');
              const rowCount = tbl.rows.length;
              const last3RowIndex = rowCount - 3;
              
              // Only store if this row is last3 (the predefined Item 11 row)
              if (i === last3RowIndex) {
                window.item11ExcludedValue = parseFloat(val13) || 0;
                window.item11ExcludedRowIndex = i;
                console.log(`Row ${i} - Item 11 (last3): Excluding Column 13 (${val13}) from v13 because it matches Column 7 (${val7Num}). Stored value: ${window.item11ExcludedValue}`);
              } else {
                // This is not last3 row, so don't store - it will be handled differently
                console.log(`Row ${i} - Item 11 (NOT last3): Excluding Column 13 (${val13}) from v13. This row is not last3, so value will not be added later.`);
              }
            }
          }
        }
        
        // Only add to v13 if not excluding
        if (!shouldExcludeFromV13) {
          v13 = parseFloat(v13) + parseFloat(val13);
        }

        const total8910 = parseFloat(val8) + parseFloat(val9) + parseFloat(val10);

        const rowNumber = tbl.rows[rowNum];
        var cell6 = rowNumber.cells[6];
        if (parseFloat(total8910) <= 20 * parseFloat(val7) / 100) {
          cell6.style.backgroundColor = 'white';
        } else {
          cell6.style.backgroundColor = '#ffaa00';
          allSoftValidactionAlertBlockJ = allSoftValidactionAlertBlockJ + " (Col. 8+ Col. 9+ Col.10) <= 20% of col. 7. \n";
          statusAlertJ = 1;
        }

        // Add debugging to understand the values
        console.log("Debug values:", {
          val5: val5, val6: val6, val7: val7, val8: val8, val9: val9, val10: val10, val11: val11,
          val13: val13
        });

        // Ensure val6 is not 0 to avoid division by zero
        if (parseFloat(val6) === 0 || isNaN(parseFloat(val6))) {
          val6 = 1;
        }

        // Column 12 calculation and validation ONLY for SI No 1 to 10 (i < 10)
        // Skip Column 12 calculation and validation for Item 11 (itemCode: '9921100') and rows beyond SI No 10
        const isItem11ForColumn12 = (String(val3).trim() === '9921100');
        const isSI1To10 = (i < 10); // Only SI No 1 to 10 (i = 0 to 9)
        
        // Initialize total12 and total13 variables at higher scope
        let total12 = 0;
        let total13 = 0;
        
        if (rowNum <= rowCount) {
          const row = tbl.rows[rowNum];
          let cell1 = row.cells[11];
          
          if (isItem11ForColumn12 || !isSI1To10) {
            // For Item 11 or rows beyond SI No 10, skip Column 12 calculation and validation
            // Column 12 should remain blank and no validation should be applied
            cell1.style.backgroundColor = 'white';
            // Remove highlighting from input field
            setPerUnitNetSaleValueClass(prev => ({
              ...prev,
              [i]: 'textBox_back_color_white'
            }));
            // Direct DOM manipulation to remove error styling
            const val12Input = document.getElementById("perunitNetsaleValue" + i);
            if (val12Input) {
              val12Input.style.border = '';
              val12Input.style.backgroundColor = '';
            }
            if (isItem11ForColumn12) {
              console.log(`⏭️ Row ${i} (Item 11): Skipping Column 12 calculation and validation - Column 12 should remain blank`);
            } else {
              console.log(`⏭️ Row ${i} (SI No ${i + 1}): Skipping Column 12 calculation and validation - Only SI No 1 to 10 have Column 12 validation`);
            }
            // total12 and total13 remain 0
          } else {
            // Calculate total12 with proper validation ONLY for SI No 1 to 10
            const val7Num = parseFloat(val7) || 0;
            const val8Num = parseFloat(val8) || 0;
            const val9Num = parseFloat(val9) || 0;
            const val10Num = parseFloat(val10) || 0;
            const val11Num = parseFloat(val11) || 0;
            // Use val6Num from Block D validation, but ensure it's at least 1 for division
            const val6NumForCalc = parseFloat(val6) || 1;

            console.log("val6Num", val6NumForCalc);

            const numerator = val7Num - (val8Num + val9Num + val10Num - val11Num);
            total12 = val6NumForCalc !== 0 ? numerator / val6NumForCalc : 0;

            // Keep total12 as number for comparison, only format for display
            total12 = isNaN(total12) ? 0 : parseFloat(total12);

            // Calculate total13 with proper validation
            // Use val12Number (user input from Column 12) and multiply with Column 5 (val5Num)
            // Round up the result (no decimal places allowed)
            const val12Input = document.getElementById("perunitNetsaleValue" + i);
            const val12Raw = val12Input ? val12Input.value.trim() : '';
            const val12Number = val12Raw !== '' && !isNaN(parseFloat(val12Raw)) ? parseFloat(val12Raw) : 0;
            const val5Num = parseFloat(val5) || 0;
            
            // Calculate: Column 12 (user input) * Column 5, then round up (no decimals)
            total13 = Math.ceil(parseFloat(val12Number) * val5Num);
            total13 = isNaN(total13) ? 0 : total13;

            console.log("total13", total13);

            // Get val12 directly from input field to ensure we have the latest value (already defined above)
            const total12Number = parseFloat(total12) || 0;
            
            // Round both values to 2 decimal places for comparison
            // This handles cases where:
            // 1. User enters 3, 4, 5 or more decimal places (e.g., 76159.00337928)
            // 2. User enters value without decimal (e.g., 76159) or with .00 (e.g., 76159.00)
            // Both will be rounded to 2 decimal places and compared
            const val12Rounded = Math.round(val12Number * 100) / 100;
            const total12Rounded = Math.round(total12Number * 100) / 100;
            
            // Use tolerance for floating point comparison (0.01 = allows difference up to 0.01)
            // This ensures that 76159, 76159.00, 76159.0 all match with calculated 76159.00
            const tolerance = 0.01;
            const difference12 = Math.abs(val12Rounded - total12Rounded);
            
          
            // Validation: If rounded values match (difference <= tolerance), validation passes
            // This handles cases where both values are same after rounding (e.g., 76159 and 76159)
            if (difference12 <= tolerance) {
              // Values match - validation PASSED
              cell1.style.backgroundColor = 'white';
              // Remove error class from input field
              setPerUnitNetSaleValueClass(prev => ({
                ...prev,
                [i]: 'textBox_back_color_white'
              }));
              // Direct DOM manipulation to remove error styling
              if (val12Input) {
                val12Input.style.border = '';
                val12Input.style.backgroundColor = '';
              }
              console.log(`✅ Row ${i} (SI No ${i + 1}) Column 12 validation PASSED: val12Rounded=${val12Rounded} === total12Rounded=${total12Rounded}, difference=${difference12} (within tolerance ${tolerance})`);
              // Don't set flagJ = 1 - validation passed, allow save
            } else {
              // Values don't match - validation FAILED
              cell1.style.backgroundColor = '#FF0000';
              // Update state for input field highlighting
              setPerUnitNetSaleValueClass(prev => ({
                ...prev,
                [i]: 'textBox_back_color_red'
              }));
              // Direct DOM manipulation for immediate visual feedback - red border
              if (val12Input) {
                val12Input.style.border = '2px solid rgb(255, 0, 0)';
                val12Input.style.backgroundColor = '';
              }
              flagJ = 1;
              console.log(`❌ Row ${i} (SI No ${i + 1}) Column 12 validation FAILED: val12Rounded=${val12Rounded} !== total12Rounded=${total12Rounded}, difference=${difference12} (exceeds tolerance ${tolerance})`);
            }
          }
        }
        
        if (rowNum <= rowCount) {
          const row = tbl.rows[rowNum];
          const cell2 = row.cells[12];
          
          // For Item 11 (itemCode: '9921100'), skip ALL Column 13 calculations and validations
          // Only Column 7 == Column 13 validation should apply (already done above)
          const isRow11Item11 = (String(val3).trim() === '9921100');
          
          if (isRow11Item11) {
            // For Item 11, skip all Column 13 calculations and validations
            // Only Column 7 == Column 13 validation applies (handled earlier in the code)
            cell2.style.backgroundColor = 'white';
            console.log(`⏭️ Row ${i} (Item 11): Skipping ALL Column 13 calculations and validations - Only Column 7 == Column 13 validation applies`);
          } else {
            // For other items, apply normal Column 13 validation
            // Keep total13 as number, don't use toFixed() for comparison
            const total13Number = parseFloat(total13) || 0;
            
            // Get val13 directly from input field to ensure we have the latest value
            const val13Input = document.getElementById("exfactoryValueQty" + i);
            const val13Raw = val13Input ? val13Input.value.trim() : '';
            const val13Number = val13Raw !== '' && !isNaN(parseFloat(val13Raw)) ? parseFloat(val13Raw) : (parseFloat(val13) || 0);
            
            // Get val12 and val5 for calculation details in console log
            const val12Input = document.getElementById("perunitNetsaleValue" + i);
            const val12Raw = val12Input ? val12Input.value.trim() : '';
            const val12Number = val12Raw !== '' && !isNaN(parseFloat(val12Raw)) ? parseFloat(val12Raw) : 0;
            const val5Num = parseFloat(val5) || 0;
            
            // Use tolerance for comparison (since values are rounded up to integers, tolerance can be 0.5)
            const tolerance13 = 0.5;
            const difference13 = Math.abs(val13Number - total13Number);
          
            if (difference13 > tolerance13) {
              // Values don't match - validation FAILED
              cell2.style.backgroundColor = '#FF0000';
              // Update state for input field highlighting
              setExFactoryValueClass(prev => ({
                ...prev,
                [i]: 'textBox_back_color_red'
              }));
              // Direct DOM manipulation for immediate visual feedback - red border
              if (val13Input) {
                val13Input.style.border = '2px solid rgb(255, 0, 0)';
                val13Input.style.backgroundColor = '';
              }
              flagJ = 1;
            } else {
              // Values match - validation PASSED
              cell2.style.backgroundColor = 'white';
              // Remove error class from input field
              setExFactoryValueClass(prev => ({
                ...prev,
                [i]: 'textBox_back_color_white'
              }));
              // Direct DOM manipulation to remove error styling
              if (val13Input) {
                val13Input.style.border = '';
                val13Input.style.backgroundColor = '';
              }
              // Don't set flagJ = 1 - validation passed, allow save
            }
          }
        }
        


      } // End of for loop (i = 0; i < rowCount - 5; i++)

      // Check if the required rows exist before accessing them - MOVED OUTSIDE LOOP
      if (rowCount >= 3) {
          const last3 = tbl.rows[rowCount - 3];
          const last2 = tbl.rows[rowCount - 2];
          const last1 = tbl.rows[rowCount - 1];

          if (last3 && last2 && last1) {

            const cell_6 = last3.getElementsByTagName('td')[6];
            const gross100 = handleValue(cell_6.querySelector('input').value);

            const cel_7 = last3.getElementsByTagName('td')[7];
            const excise100 = handleValue(cel_7.querySelector('input').value);

            const cel_8 = last3.getElementsByTagName('td')[8];
            const salesTax100 = handleValue(cel_8.querySelector('input').value);

            const cel_9 = last3.getElementsByTagName('td')[9];
            const others100 = handleValue(cel_9.querySelector('input').value);

            const cel_10 = last3.getElementsByTagName('td')[10];
            const total100 = handleValue(cel_10.querySelector('input').value);

            const cel_12 = last3.getElementsByTagName('td')[12];
            const exFactory100 = handleValue(cel_12.querySelector('input').value);

            const cel06 = last2.getElementsByTagName('td')[6];
            const gross101 = handleValue(cel06.querySelector('input').value);

            const cel07 = last2.getElementsByTagName('td')[7];
            const excise101 = handleValue(cel07.querySelector('input').value);

            const cel08 = last2.getElementsByTagName('td')[8];
            const salesTax101 = handleValue(cel08.querySelector('input').value);

            const cel09 = last2.getElementsByTagName('td')[9];
            const others101 = handleValue(cel09.querySelector('input').value);

            const cel10 = last2.getElementsByTagName('td')[10];
            const total101 = handleValue(cel10.querySelector('input').value);

            const cel12 = last2.getElementsByTagName('td')[12];
            const exFactory101 = handleValue(cel12.querySelector('input').value);

            // IMPORTANT: v7, v8, v9, v10, v11 already contain sum of Item 1 to Item 11 from the loop
            // last3 (rowCount - 3) is Row 11 (Item 11), which is already included in the loop
            // So we should NOT add gross100, excise100, etc. again
            // The loop already processed rows 0 to (rowCount - 6), which includes Item 11
            // last3 is at index (rowCount - 3), which is AFTER the loop ends
            // But wait - if loop goes from 0 to (rowCount - 5), then:
            // - Loop processes: rows 0, 1, 2, ..., (rowCount - 6)
            // - last3 is at: (rowCount - 3)
            // - Since (rowCount - 3) > (rowCount - 6), last3 is NOT in the loop
            // However, Item 11 might be at a different index
            
            // Actually, the issue is that last3 might be Item 11, which is already in the loop
            // Let's check: if last3's itemCode is '9921100' (Item 11), and Item 11 is already in loop, don't add
            const last3RowIndexForV7 = rowCount - 3;
            const loopEndIndex = rowCount - 5;
            const last3ItemCodeForV7 = document.getElementById("itemCode" + last3RowIndexForV7);
            const isLast3Item11ForV7 = last3ItemCodeForV7 && String(last3ItemCodeForV7.value).trim() === '9921100';
            
            console.log(`🔍 Checking last3 for v7 calculation:`, {
              last3RowIndex: last3RowIndexForV7,
              loopEndIndex: loopEndIndex,
              isLast3InLoop: last3RowIndexForV7 < loopEndIndex,
              isLast3Item11: isLast3Item11ForV7,
              gross100: gross100,
              currentV7: v7
            });
            
            // IMPORTANT: v7 already contains sum of SI No 1 to SI No 11 (Row 0 to Row 10) from the loop
            // last3 (rowCount - 3) is a separate row that might be Item 11 again or empty
            // Since SI No 1 to SI No 11 are already in the loop, we should NOT add last3's values to v7
            // v7 should ONLY contain Item 1 to Item 11 sum, nothing more
            
            // Check if last3 is Item 11 - if yes, definitely skip (already in loop as SI No 11)
            // Even if last3 is NOT Item 11, we should skip it because:
            // - Loop processes SI No 1 to SI No 11 (Row 0 to Row 10)
            // - last3 is at (rowCount - 3), which is AFTER the loop
            // - But v7 should only contain SI No 1 to SI No 11 sum
            // - last3 might be a duplicate or empty row, so don't add it
            
            if (isLast3Item11ForV7) {
              // last3 is Item 11, which is already in the loop (SI No 11)
              // So don't add gross100 again
              console.log(`⏭️ Skipping last3 (Row ${last3RowIndexForV7}, Item 11) values - already included in loop as SI No 11. gross100=${gross100} will NOT be added.`);
            } else {
              // last3 is NOT Item 11, but we still don't add it because:
              // v7 should ONLY contain SI No 1 to SI No 11 sum (from loop)
              // last3 is a separate row that should NOT be included in the total
              console.log(`⏭️ Skipping last3 (Row ${last3RowIndexForV7}, Not Item 11) values - v7 should only contain SI No 1 to SI No 11 sum. gross100=${gross100} will NOT be added.`);
            }
            
            // Final v7 should be sum of SI No 1 to SI No 11 only (already calculated in loop)
            console.log(`✅ Final v7 (SI No 1 to SI No 11 sum) = ${v7}`);
            
            // Handle last3 (rowCount - 3) value addition to v13
            // last3 is the predefined "Other products/by-products" row
            const last3RowIndex = rowCount - 3;
            const last3ItemCodeInput = document.getElementById("itemCode" + last3RowIndex);
            const isLast3Item11 = last3ItemCodeInput && String(last3ItemCodeInput.value).trim() === '9921100';
            
            if (isLast3Item11) {
              // last3 row is Item 11
              // Check if it was excluded in loop (Column 7 == Column 13)
              // Only add excluded value if it's from last3 row
              if (window.item11ExcludedValue !== null && window.item11ExcludedValue !== undefined && window.item11ExcludedRowIndex === last3RowIndex) {
                // Item 11 from last3 was excluded in loop, add the excluded value
                v13 = parseFloat(v13) + parseFloat(window.item11ExcludedValue);
                console.log(`last3 (Row ${last3RowIndex}, Item 11): Adding excluded value (${window.item11ExcludedValue}) to v13. New v13: ${v13}`);
                // Reset the stored values
                window.item11ExcludedValue = null;
                window.item11ExcludedRowIndex = null;
              } else {
                // Item 11 was NOT excluded in loop (Column 7 != Column 13), so it was already added in loop
                // Don't add exFactory100 because it's the same value that was already added
                console.log(`last3 (Row ${last3RowIndex}, Item 11): Not adding to v13 because it was already added in loop (Column 7 != Column 13)`);
                // Reset stored values if they exist but are from different row
                if (window.item11ExcludedValue !== null) {
                  console.log(`Note: Excluded Item 11 value exists but is from row ${window.item11ExcludedRowIndex}, not last3 (${last3RowIndex}). Not adding.`);
                  window.item11ExcludedValue = null;
                  window.item11ExcludedRowIndex = null;
                }
              }
            } else {
              // last3 row is NOT Item 11, add it normally
              v13 = parseFloat(v13) + parseFloat(exFactory100);
              console.log(`last3 (Row ${last3RowIndex}, Not Item 11): Adding Column 13 (${exFactory100}) to v13`);
              // Reset stored values if they exist (they're from a different row)
              if (window.item11ExcludedValue !== null) {
                console.log(`Note: Excluded Item 11 value exists but last3 is not Item 11. Not adding excluded value.`);
                window.item11ExcludedValue = null;
                window.item11ExcludedRowIndex = null;
              }
            }
            
            // Convert to number (not string) for comparison
            v13 = parseFloat(v13) || 0;

            const row = tbl.rows[rowCount - 2];
            const row11 = tbl.rows[rowCount - 2];
            let cell7 = row.cells[6];
            let cell111 = row11.cells[12];

            if (parseFloat(exFactory100) > 0) {
              if (parseFloat(exFactory100) <= 7 * exFactory101 / 100) {
                cell111.style.backgroundColor = 'white';
              } else {
                cell111.style.backgroundColor = '#ffaa00';
                allSoftValidactionAlertBlockJ = allSoftValidactionAlertBlockJ + " Col 13. Item 11 <=7% col. 13 item 12 \n";
                statusAlertJ = 1;
              }
            }

            // Total Row Column 7 validation with tolerance for floating point comparison
            const v7Num = parseFloat(v7) || 0;
            const gross101Num = parseFloat(gross101) || 0;
            const difference7 = Math.abs(v7Num - gross101Num);
            const toleranceTotal = 0.01; // Tolerance for total row validations
            
            console.log(`📋 SI No 12 Column 7 Calculation Summary:`, {
              'v7 (Calculated Sum)': v7Num,
              'gross101 (User Entered)': gross101Num,
              'difference': difference7,
              'tolerance': toleranceTotal,
              'validation': difference7 <= toleranceTotal ? 'PASSED' : 'FAILED',
              'Note': 'v7 = Sum of Item 1 to Item 11 Column 7 values from loop' + (isLast3Item11ForV7 ? ' (last3 Item 11 skipped)' : '')
            });
            
            if (difference7 > toleranceTotal) {
              cell7.style.backgroundColor = '#FF0000';
              flagJ = 1;
              console.log(`❌ Validation FAILED: Total Row Column 7 - v7 (${v7Num}) !== gross101 (${gross101Num}), difference=${difference7}`);
            } else {
              cell7.style.backgroundColor = 'white';
              console.log(`✅ Validation PASSED: Total Row Column 7 - v7 (${v7Num}) === gross101 (${gross101Num}) (within tolerance)`);
            }
            
            // Total Row Column 8 validation with tolerance
            let cell8 = row.cells[7];
            const v8Num = parseFloat(v8) || 0;
            const excise101Num = parseFloat(excise101) || 0;
            const difference8 = Math.abs(v8Num - excise101Num);
            
            if (difference8 > toleranceTotal) {
              cell8.style.backgroundColor = '#FF0000';
              flagJ = 1;
              console.log(`❌ Validation FAILED: Total Row Column 8 - v8 (${v8Num}) !== excise101 (${excise101Num}), difference=${difference8}`);
            } else {
              cell8.style.backgroundColor = 'white';
              console.log(`✅ Validation PASSED: Total Row Column 8 - v8 (${v8Num}) === excise101 (${excise101Num}) (within tolerance)`);
            }
            
            // Total Row Column 9 validation with tolerance
            let cell9 = row.cells[8];
            const v9Num = parseFloat(v9) || 0;
            const salesTax101Num = parseFloat(salesTax101) || 0;
            const difference9 = Math.abs(v9Num - salesTax101Num);
            
            if (difference9 > toleranceTotal) {
              cell9.style.backgroundColor = '#FF0000';
              flagJ = 1;
              console.log(`❌ Validation FAILED: Total Row Column 9 - v9 (${v9Num}) !== salesTax101 (${salesTax101Num}), difference=${difference9}`);
            } else {
              cell9.style.backgroundColor = 'white';
              console.log(`✅ Validation PASSED: Total Row Column 9 - v9 (${v9Num}) === salesTax101 (${salesTax101Num}) (within tolerance)`);
            }
            
            // Total Row Column 10 validation with tolerance
            let cell10 = row.cells[9];
            const v10Num = parseFloat(v10) || 0;
            const others101Num = parseFloat(others101) || 0;
            const difference10 = Math.abs(v10Num - others101Num);
            
            if (difference10 > toleranceTotal) {
              cell10.style.backgroundColor = '#FF0000';
              flagJ = 1;
              console.log(`❌ Validation FAILED: Total Row Column 10 - v10 (${v10Num}) !== others101 (${others101Num}), difference=${difference10}`);
            } else {
              cell10.style.backgroundColor = 'white';
              console.log(`✅ Validation PASSED: Total Row Column 10 - v10 (${v10Num}) === others101 (${others101Num}) (within tolerance)`);
            }
            
            // Total Row Column 11 validation with tolerance
            let cell11 = row.cells[10];
            const v11Num = parseFloat(v11) || 0;
            const total101Num = parseFloat(total101) || 0;
            const difference11 = Math.abs(v11Num - total101Num);
            
            if (difference11 > toleranceTotal) {
              cell11.style.backgroundColor = '#FF0000';
              flagJ = 1;
              console.log(`❌ Validation FAILED: Total Row Column 11 - v11 (${v11Num}) !== total101 (${total101Num}), difference=${difference11}`);
            } else {
              cell11.style.backgroundColor = 'white';
              console.log(`✅ Validation PASSED: Total Row Column 11 - v11 (${v11Num}) === total101 (${total101Num}) (within tolerance)`);
            }
            // row11 = tbl.rows[rowCount - 2];
            let cell13 = row11.cells[12];

            // Check if Row 11 (Item 11) has matching Column 7 and Column 13 values
            // If they match, don't apply total validation error to Row 11's Column 13
            let row11Item11Column13Matches = false;
            const row11ItemCodeInput = document.getElementById("itemCode" + 10); // Row 11 is index 10 (0-based)
            if (row11ItemCodeInput) {
              const row11ItemCode = String(row11ItemCodeInput.value).trim();
              if (row11ItemCode === '9921100') {
                // Check if Item 11 validation already passed
                if (window.item11ValidationPassed && window.item11ValidationPassed[10]) {
                  row11Item11Column13Matches = true;
                } else {
                  // Double check by reading values directly
                  const row11Val7Input = document.getElementById("grossSaleValue" + 10);
                  const row11Val13Input = document.getElementById("exfactoryValueQty" + 10);
                  if (row11Val7Input && row11Val13Input) {
                    const row11Val7Raw = row11Val7Input.value.trim();
                    const row11Val13Raw = row11Val13Input.value.trim();
                    const row11Val7Num = row11Val7Raw !== '' && !isNaN(parseFloat(row11Val7Raw)) ? parseFloat(row11Val7Raw) : 0;
                    const row11Val13Num = row11Val13Raw !== '' && !isNaN(parseFloat(row11Val13Raw)) ? parseFloat(row11Val13Raw) : 0;
                    
                    // If Column 7 and Column 13 match for Row 11, don't show total validation error
                    if (row11Val7Num > 0 && Math.abs(row11Val13Num - row11Val7Num) <= 0.01) {
                      row11Item11Column13Matches = true;
                    }
                  }
                }
              }
            }

            // For total validation: v13 should equal exFactory101
            // v13 = sum of Item 1 to Item 11 Column 13 values (calculated in loop + Row 11)
            // exFactory101 = Total row (Item 12) Column 13 value which is sum of Item 1 to Item 11
            const v13Num = parseFloat(v13) || 0;
            const exFactory101Num = parseFloat(exFactory101) || 0;
            const difference = Math.abs(v13Num - exFactory101Num);
            
            // Use tolerance for floating point comparison
            const tolerance = 0.01;
            
            // Calculate the index for SI No 12 (Total Row) in itemData array
            const dataLength = Object.keys(itemData).length;
            const siNo12Index = dataLength - 2; // SI No 12 is second last row
            
            console.log(`🔴 Total Validation Check (Row 12 - Total Row):`, {
              v13: v13Num,
              exFactory101: exFactory101Num,
              difference: difference,
              tolerance: tolerance,
              valuesMatch: difference <= tolerance,
              row11Item11Column13Matches: row11Item11Column13Matches,
              siNo12Index: siNo12Index,
              'Row 11 Item 11 Values': row11Item11Column13Matches ? {
                val7Input: document.getElementById("grossSaleValue" + 10)?.value,
                val13Input: document.getElementById("exfactoryValueQty" + 10)?.value
              } : 'N/A',
              'Calculation': {
                'v13 includes': 'Item 1 to Item 11 Column 13 values (loop + Row 11)',
                'exFactory101 is': 'Total row (Item 12) Column 13 = sum of Item 1 to Item 11'
              }
            });
            
            // Normal validation - compare v13 with exFactory101 - ONLY ONCE AFTER ALL CALCULATIONS
            // Store the flagJ value before total validation to check if it was set by total validation
            const flagJBeforeTotalValidation = flagJ;
            
            if (difference > tolerance) {
              cell13.style.backgroundColor = '#FF0000';
              // Update state to show error on SI No 12 Column 13 input field (only border, no background)
              setExFactoryValueClass(prev => ({
                ...prev,
                [siNo12Index]: 'textBox_back_color_red'
              }));
              // Direct DOM manipulation for immediate visual feedback - only red border
              const siNo12Input = document.getElementById(`exfactoryValueQty${siNo12Index}`);
              if (siNo12Input) {
                siNo12Input.style.border = '2px solid rgb(255, 0, 0)';
                siNo12Input.style.backgroundColor = '';
                siNo12Input.style.color = '';
              }
              flagJ = 1;
              console.log(`❌ Total validation FAILED: v13=${v13Num} !== exFactory101=${exFactory101Num}, difference=${difference}, siNo12Index=${siNo12Index}`);
            } else {
              cell13.style.backgroundColor = 'white';
              // Remove error class from SI No 12 Column 13 input field
              setExFactoryValueClass(prev => ({
                ...prev,
                [siNo12Index]: 'textBox_back_color_white'
              }));
              // Direct DOM manipulation to remove error styling
              const siNo12Input = document.getElementById(`exfactoryValueQty${siNo12Index}`);
              if (siNo12Input) {
                siNo12Input.style.border = '';
                siNo12Input.style.backgroundColor = '';
                siNo12Input.style.color = '';
              }
              console.log(`✅ Total validation PASSED: v13=${v13Num} === exFactory101=${exFactory101Num} (within tolerance)`);
              // If flagJ was set to 1 only because of total validation failure, reset it now
              // But if other validations set it to 1, keep it as 1
              // Since total validation passed, if flagJ was 0 before, keep it 0
              // If flagJ was 1 before (due to other validations), keep it 1
              // We only want to ensure that total validation passing doesn't cause flagJ to be 1
              if (flagJBeforeTotalValidation === 0) {
                // No other validation errors, so ensure flagJ is 0 for total validation pass
                flagJ = 0;
                console.log(`✅ Total validation PASSED: flagJ reset to 0 (no other validation errors)`);
              } else {
                // Other validations have errors, keep flagJ as 1
                console.log(`⚠️ Total validation PASSED but flagJ remains 1 due to other validation errors`);
                console.log(`🔍 Debugging: Checking which validations might have set flagJ = 1:`);
                console.log(`   - Check Item 11 Column 7 and Column 13 validation`);
                console.log(`   - Check Column 5, 6, 7 validations`);
                console.log(`   - Check Column 12 and Column 13 row validations`);
                console.log(`   - Check Total row validations (v7, v8, v9, v10, v11)`);
                console.log(`   - Check allValidactionAlertBlockJ:`, allValidactionAlertBlockJ);
              }
            }

            if (blockgdata === 0) {
              if (parseFloat(exFactory101) === 0) {
                alert("Data Entry is compulsory for Block G or Block J (i.e. anyone of Block G or Block J). if the factory's status code is open");
              }
            }
          } // End of if (last3 && last2 && last1)
        } // End of if (rowCount >= 3)
      
      // Update state with all class changes before showing alerts
      // Create a new object with updated classes
      const updatedItemData = {};
      for (let idx in itemData) {
        updatedItemData[idx] = {
          ...itemData[idx],
          qtyManufacturedClass: itemData[idx].qtyManufacturedClass || 'textBox_back_color_white',
          qtySoldClass: itemData[idx].qtySoldClass || 'textBox_back_color_white'
        };
      }
      setItemData(updatedItemData);

      if (statusAlertJ === 1 && allSoftValidactionAlertBlockJ.length > 0) {
        allSoftValidactionAlertBlockJ = allSoftValidactionAlertBlockJ + " \nFor change any Values Click OK."
        const clicked = window.confirm(allSoftValidactionAlertBlockJ);
        allSoftValidactionAlertBlockJ = "";
        if (clicked) {
          // Ask user if they still want to save the data for Block J
          const confirmSave = window.confirm("Are you still want to save the data for Block J?");
          if (!confirmSave) {
            statusAlertJ = 0;
            return false;
          }
          // If user confirms, allow save to proceed
          statusAlertJ = 0;
        } else {
          statusAlertJ = 0;
          return false;
        }
      }
      if (flagJ === 1) {
        // Show detailed error messages to help user identify which validation failed
        let errorMessage = '';
        if (allValidactionAlertBlockJ && allValidactionAlertBlockJ.trim() !== '') {
          errorMessage = allValidactionAlertBlockJ + " \n" + 'Total does not match. Please check highlighted fields.';
        } else {
          errorMessage = 'Total does not match. Please check highlighted fields.';
        }
        
        if (statusAlertJ === 1) {
          alert(errorMessage);
          statusAlertJ = 0;
        } else {
          alert(errorMessage);
        }
        console.log(`🚫 Validation FAILED - flagJ = 1. Error messages:`, allValidactionAlertBlockJ);
        flagJ = 0;
        return false;
      }
    } else {

      
    }
    return true
  }

  const storedLanguage = localStorage.getItem('language');

  return (
    <div className="card-body">
      {/* <ToastContainer /> */}
      <h4 className="page_heading border-bottom-0">
        <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_J_TITLE : asiTitle.en.BLOCK_J_TITLE }} />
      </h4>
      <div className="row">
        <div className="col-12">
          <h6 className="fw-semibold">
            {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
            {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
          </h6>
          <div className="table-responsive  asi_block_table">
            <table cellPadding="0" cellSpacing="0" id="velBlockJ" ref={dtableRef} className="table table-bordered block_c_table">
              <thead>
                <tr>
                  <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                  <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.PRODUCT_DESCRIPTION : asiTitle.en.PRODUCT_DESCRIPTION}</th>
                  <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.ITEM_CODE : asiTitle.en.ITEM_CODE}</th>
                  <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.UNIT_OF_QTY : asiTitle.en.UNIT_OF_QTY}</th>
                  <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.QUANTITY_MANUFACTURED : asiTitle.en.QUANTITY_MANUFACTURED }} /></th>
                  <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.QTY_SOLD : asiTitle.en.QTY_SOLD}</th>
                  <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.GROSS_SALE : asiTitle.en.GROSS_SALE }} /></th>
                  <th className="text-center" colSpan="4">{storedLanguage === 'hi' ? asiTitle.hi.DISTRIBUTIVE_EXPENSES : asiTitle.en.DISTRIBUTIVE_EXPENSES}</th>
                  <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.PER_UNIT_SALE : asiTitle.en.PER_UNIT_SALE }} /></th>
                  <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.EX_FACTORY_VALUE : asiTitle.en.EX_FACTORY_VALUE }} /></th>
                </tr>
                <tr>
                  <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.GST : asiTitle.en.GST}</th>
                  <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.EXERCISE_DUTY : asiTitle.en.EXERCISE_DUTY}</th>
                  <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.OTHER_DISTRIBUTIVE_EXPENSES : asiTitle.en.OTHER_DISTRIBUTIVE_EXPENSES}</th>
                  <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.SUBSIDY : asiTitle.en.SUBSIDY}</th>
                </tr>

                <tr>
                  <th className="text-center">1</th>
                  <th className="text-center">2</th>
                  <th className="text-center">3</th>
                  <th className="text-center">4</th>
                  <th className="text-center">5</th>
                  <th className="text-center">6</th>
                  <th className="text-center">7</th>
                  <th className="text-center">8</th>
                  <th className="text-center">9</th>
                  <th className="text-center">10</th>
                  <th className="text-center">11</th>
                  <th className="text-center">12</th>
                  <th className="text-center">13</th>
                </tr>
              </thead>

              <tbody>

                {Object.values(itemData).map((item, i) => {
                  let isDisable = false;
                  let isIndex = false;
                  let dataLength = Object.values(itemData).length;
                  if (i >= dataLength - 3) {
                    isIndex = true;

                  }

                  if (itemCodeArray.includes(itemData[item.id].itemCode) &&
                    i >= dataLength - 3) {
                    isDisable = true
                  }
                  if (staticNo === srNo) {
                    srNo = 14;
                  }

                  return (<tr key={i}>
                    <td>{(isIndex) ? ++staticNo : ++srNo}
                      {![dataLength - 1, dataLength - 2, dataLength - 3].includes(i) &&
                        <> -
                          <input
                            type="checkbox"
                            id={`checkbox-${i}-id`}
                            checked={checkedItems.includes(i)}
                            onChange={(event) => handleCheckboxChange(event, i)}
                          />
                        </>
                      }

                    </td>

                    <td>
                      <input
                        type="text"
                        className={`form-control ${['9995000'].includes(itemData[item.id].itemCode) ? 'text-bold-inside-textbox' : ''}`}
                        value={itemData[item.id].itemDesc || ''}
                        id={`itemDesc${i}`}
                        name={`itemDesc${i}`}
                        disabled
                      />
                    </td>
                    <td className={`${itemData[item.id].itemCodeClass}`}>

                      <input
                        type="text"
                        className="form-control"
                        value={isDisable && (itemData[item.id].itemCode === '0' || itemData[item.id].itemCode === 0) ? '' : (itemData[item.id].itemCode || '')}
                        id={`itemCode${i}`}
                        name={`itemCode${i}`}
                        disabled={isDisable}
                        maxLength="7"
                        onChange={e => handleOnChange(item.id, 'itemCode', e.target.value)}
                        onFocus={e => handleOnFocus(item.id, 'itemCode')}
                        onBlur={e => handleOnBlur(item.id, e.target.value)}
                      />
                    </td>
                    <td>

                      <input
                        type="text"
                        className="form-control"
                        value={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].unitOfQty === '0' || itemData[item.id].unitOfQty === 0) ? '' : (itemData[item.id].unitOfQty || '')}
                        id={`unitOfQty${i}`}
                        name={`unitOfQty${i}`}
                        maxLength="20"
                        disabled={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode)}
                      />
                    </td>
                    <td className={itemData[item.id]?.qtyManufacturedClass || 'textBox_back_color_white'}>

                      <input
                        type="text"
                        className="form-control"
                        value={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].qtyManufactured === '0' || itemData[item.id].qtyManufactured === 0) ? '' : (itemData[item.id].qtyManufactured || '')}
                        id={`qtyManufactured${i}`}
                        name={`qtyManufactured${i}`}
                        maxLength="15"
                        onChange={e => handleOnChange(item.id, 'qtyManufactured', e.target.value)}
                        disabled={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode)}
                      />
                    </td>
                    <td className={itemData[item.id]?.qtySoldClass || 'textBox_back_color_white'}>
                      <input
                        type="text"
                        className="form-control"
                        value={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].qtySold === '0' || itemData[item.id].qtySold === 0) ? '' : (itemData[item.id].qtySold || '')}
                        id={`qtySold${i}`}
                        name={`qtySold${i}`}
                        maxLength="15"
                        onChange={e => handleOnChange(item.id, 'qtySold', e.target.value)}
                        disabled={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={['9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].grossSaleValue === '0' || itemData[item.id].grossSaleValue === 0) ? '' : (itemData[item.id].grossSaleValue || '')}
                        id={`grossSaleValue${i}`}
                        name={`grossSaleValue${i}`}
                        maxLength="12"
                        onChange={e => handleOnChange(item.id, 'grossSaleValue', e.target.value)}
                        disabled={['9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={['9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].distributiveExpensesExciseDuty === '0' || itemData[item.id].distributiveExpensesExciseDuty === 0) ? '' : (itemData[item.id].distributiveExpensesExciseDuty || '')}
                        id={`distributiveExpensesExciseDuty${i}`}
                        name={`distributiveExpensesExciseDuty${i}`}
                        maxLength="12"
                        onChange={e => handleOnChange(item.id, 'distributiveExpensesExciseDuty', e.target.value)}
                        disabled={['9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={['9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].distributiveExpensesSalesTaxVat === '0' || itemData[item.id].distributiveExpensesSalesTaxVat === 0) ? '' : (itemData[item.id].distributiveExpensesSalesTaxVat || '')}
                        id={`distributiveExpensesSalesTaxVat${i}`}
                        name={`distributiveExpensesSalesTaxVat${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'distributiveExpensesSalesTaxVat', e.target.value)}
                        disabled={['9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={['9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].distributiveExpensesOthers === '0' || itemData[item.id].distributiveExpensesOthers === 0) ? '' : (itemData[item.id].distributiveExpensesOthers || '')}
                        id={`distributiveExpensesOthers${i}`}
                        name={`distributiveExpensesOthers${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'distributiveExpensesOthers', e.target.value)}
                        disabled={['9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={['9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].distributiveExpensesTotal === '0' || itemData[item.id].distributiveExpensesTotal === 0) ? '' : (itemData[item.id].distributiveExpensesTotal || '')}
                        id={`distributiveExpensesTotal${i}`}
                        name={`distributiveExpensesTotal${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'distributiveExpensesTotal', e.target.value)}
                        disabled={['9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td className={perUnitNetSaleValueClass[i] || 'textBox_back_color_white'}>
                      <input
                        type="text"
                        className="form-control"
                        style={perUnitNetSaleValueClass[i] === 'textBox_back_color_red' ? { border: '2px solid rgb(255, 0, 0)' } : {}}
                        value={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode) && (itemData[item.id].perunitNetsaleValue === '0' || itemData[item.id].perunitNetsaleValue === 0) ? '' : (itemData[item.id].perunitNetsaleValue || '')}
                        id={`perunitNetsaleValue${i}`}
                        name={`perunitNetsaleValue${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'perunitNetsaleValue', e.target.value)}
                        disabled={['9921100', '9995000', '9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td className={exFactoryValueClass[i] || 'textBox_back_color_white'}>
                      <input
                        type="text"
                        className="form-control"
                        style={exFactoryValueClass[i] === 'textBox_back_color_red' ? { border: '2px solid rgb(255, 0, 0)' } : {}}
                        value={itemData[item.id].exfactoryValueQty}
                        id={`exfactoryValueQty${i}`}
                        name={`exfactoryValueQty${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'exfactoryValueQty', e.target.value)}
                      />
                    </td>


                  </tr>)


                })}


              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div className="row">
        <div className="col-12">
          <hr />
        </div>
        <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
          <button
            type="submit"
            className="btn btn_orange me-1"
            onClick={() => { window.print() }}
          >
            Print
            <i className="fa fa-print ms-1"></i>
          </button>

          <button
            type="button"
            className="btn btn_orange me-1"
            onClick={() => handleSaveData("SAVE")}
            disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
          >
            Save
          </button>

          <button
            type="reset"
            className="btn btn_orange me-1"
            onClick={handleReset}
          >
            Reset
          </button>

          <button
            type="button"
            className="btn btn_orange me-1"
            onClick={(e) => (navigate("/dashboard"))}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-success me-1 px-3"
            onClick={addRow}
          >
            <i className="fa fa-plus-circle me-1"></i>
            Add Row
          </button>

          <button
            type="button"
            className="btn btn_red px-3"
            onClick={DeleteRow}
          >
            <i className="fa fa-minus-circle me-1"></i>
            Delete Row
          </button>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handlePrevious}
          >
            <i className="fa fa-angle-left me-1"></i>
            Previous
          </button>

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handleNext}
            disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
          >
            Next
            <i className="fa fa-angle-right ms-1"></i>
          </button>

        </div>
      </div>
    </div>
  )
}

